import { render, staticRenderFns } from "./AssignPermissionsToRoleForAdd.vue?vue&type=template&id=261e488e&"
import script from "./AssignPermissionsToRoleForAdd.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionsToRoleForAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports